import React, { useState, useEffect } from "react";
import {
  notification,
  message,
  Button,
  Select,
  Modal,
  Progress,
  Row,
  Col,
  Tag,
  Table,
  Alert,
  Tooltip,
} from "antd";
import {
  DownloadOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  FilePdfOutlined,
  CloseOutlined,
  InfoCircleOutlined,
  FileTextOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import getDetalleVisitaPorTipo from "../../services/visitas_tecnicas/getDetalleVisitasportipoService";
import { postSoportePatti } from "../../services/visitas_tecnicas/postAlmacenarSoportePatti";
import { pdf } from "@react-pdf/renderer";
import PdfAlmacenarConsentimiento from "./Consentimiento/consentimiento_pdf_almacenar";
import PdfAlmacenarDiagnostico from "./Diagnostico/exportable/diagnostico_pdf_almacenar";
import PdfAlmacenarAnalisisCapacidades from "./AnalisisCapacidades/exportable/analisis_capacidades_pdf_almacenar";
import PdfAlmacenarAutorizacionImagen from "./Autorizacion_imagen/exportable.jsx/autorizacion_imagen_pdf_almacenar";
import PdfAlmacenarActaInicio from "./ActaInicio/Acta_inicio_pdf_almacenar";
import { useSelector } from "react-redux";
import getVisitaPorTipoAndCodigo from "../../services/visitas_tecnicas/getVisitaPorTipoAndCodigoService";
import getDetalleActaInicio from "../../services/visitas_tecnicas/getDetalleActaInicio";
import obtenerCategoriasProductos from "../../services/visitas_tecnicas/getCategoriaProductosService";
import getVisitasTecnicas from "../../services/visitas_tecnicas/visita_tecnica/getVisitasTecnicasService";
import PdfAlmacenarVisitaTecnica from "./VisitaTecnica/pdfVisitaTecnicaAlmacenar";
import { postSoporteVisitaTecnicaPatti } from "../../services/visitas_tecnicas/visita_tecnica/postAlmacenarSoporteVisitaTecnicaPaati";
import getNovedades from "../../services/novedades/getNovedades";
import PdfAlmacenarNovedad from "../Novedades/PdfNovedadAlmacenar";
import { postSoporteNovedad } from "../../services/novedades/postAlmacenarSoporteNovedad";
import getVisitaTecnicaById from "../../services/visitas_tecnicas/visita_tecnica/getVisitaTecnicaByIdService";
import getNovedadById from "../../services/novedades/getNovedadByIdService";
import PdfAlmacenarMedicionCapacidadSalida from "./medicionCapacidadesSalida/exportable/medicion_capacidades_salida_pdf_almacenar";

const { Option } = Select;

const GenerarTodosLosPDFs = ({ fetchSystemFyle }) => {
  const [datosPrecargados, setDatosPrecargados] = useState([]);
  const [loading, setLoading] = useState(false);

  const usernameFromState = useSelector((state) => state.auth.user);

  const [progreso, setProgreso] = useState(0);
  const [total, setTotal] = useState(0);
  const [resumen, setResumen] = useState({}); // Aquí guardaremos los contadores por tipo
  const [procesoIniciado, setProcesoIniciado] = useState(false);

  const [modalVisible, setModalVisible] = useState(false);

  const [detalleErrores, setDetalleErrores] = useState([]);
  const [modalErroresVisible, setModalErroresVisible] = useState(false);
  const [tipoSeleccionado, setTipoSeleccionado] = useState("");

  const getNombreTipoPorId = (id) => {
    const tipos = {
      1: { nombre: "Consentimiento", descripcion: "consentimiento" },
      2: { nombre: "Diagnostico", descripcion: "Diagnóstico" },
      3: { nombre: "Capacidades", descripcion: "Analisis de capacidades" },
      4: { nombre: "Autorizacion", descripcion: "Autorización de imagen" },
      5: { nombre: "Acta_inicio", descripcion: "Acta de inicio" },
      8: {
        nombre: "Medicion_capacidades_salida",
        descripcion: "Medición de capacidades de salida",
      },
    };

    return (
      tipos[id] || {
        nombre: "Desconocido",
        descripcion: "Formato no identificado",
      }
    );
  };

  // Definir color dinámico
  const getColor = (percent) => {
    if (percent < 25) return "#ff4d4f"; // Rojo
    if (percent < 50) return "#faad14"; // Amarillo
    if (percent < 75) return "#fadb14"; // Naranja
    return "#52c41a"; // Verde
  };

  const fetchData = async () => {
    try {
      setLoading(true);

      // Consultar visitas técnicas y novedades
      const visitasTecnicas = await fetchVisitasTecnicas();
      const novedades = await fetchNovedades();

      // Consultar los tipos 1, 2, 3, 4, 5
      const tiposIds = [1, 2, 3, 4, 5, 8];
      const tiposVisitas = [];

      for (const id of tiposIds) {
        const detalle = await fetchDetalleVisitas(id);
        const { nombre, descripcion } = getNombreTipoPorId(id);

        tiposVisitas.push({
          id,
          nombreTipo: nombre,
          descripcion: descripcion,
          datosProcesados: detalle,
        });
      }

      // Armar lista consolidada
      const datosFinales = [
        ...tiposVisitas,
        {
          id: 6,
          nombreTipo: "Visita",
          descripcion: "Visitas técnicas",
          datosProcesados: visitasTecnicas || [],
        },
        {
          id: 7,
          nombreTipo: "Novedad",
          descripcion: "Novedades",
          datosProcesados: novedades || [],
        },
      ];

      setDatosPrecargados(datosFinales);
    } catch (error) {
      console.error("Error al cargar los datos iniciales", error);
      notification.error({
        message: "Error",
        description: "Ocurrió un error al cargar los datos iniciales.",
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const fetchDetalleVisitas = async (id) => {
    try {
      const response = await getDetalleVisitaPorTipo(
        id,
        usernameFromState.email
      );
      const { status, results } = response;

      if (status === 200) {
        return results.filter(
          (item) => item.estado_formulario === 1 && item.ruta_pdf === null
        );
      } else {
        notification.error({
          message: "Error",
          description: "No se pudo obtener la información de visitas.",
        });
        return [];
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Ocurrió un error al obtener los datos.",
      });
      return [];
    }
  };

  const fetchVisitasTecnicas = async () => {
    try {
      const response = await getVisitasTecnicas(usernameFromState.email);
      const { status, data } = response;

      if (status === 200) {
        const visitasFiltradas = data.filter(
          (visita) => visita.ruta_pdf === null
        );
        return visitasFiltradas;
      } else {
        notification.error({
          message: "Error",
          description: "No se pudo obtener las visitas técnicas.",
        });
        return []; // ✅ IMPORTANTE: Siempre retornar array
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Ocurrió un error al obtener las visitas técnicas.",
      });
      return []; // ✅ IMPORTANTE: Siempre retornar array
    }
  };

  const fetchNovedades = async () => {
    try {
      const response = await getNovedades(usernameFromState.email);
      const { status, data } = response;

      if (status === 200) {
        // Filtrar solo las novedades donde ruta_pdf sea null
        const novedadesFiltradas = data.filter(
          (novedad) => novedad.ruta_pdf === null
        );
        return novedadesFiltradas; // ✅ Siempre retorna los datos
      } else {
        notification.error({
          message: "Error",
          description: "No se pudo obtener las novedades.",
        });
        return []; // ✅ Retornar array vacío si falla
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Ocurrió un error al obtener las novedades.",
      });
      return []; // ✅ Retornar array vacío si falla
    }
  };

  const obtenerDatosCompletosDiagnostico = async (formData) => {
    try {
      const detalle = await getVisitaPorTipoAndCodigo(
        formData.id_participante,
        3
      );

      if (detalle?.detalle) {
        return {
          ...formData,
          firma_tecnico: detalle.detalle.firma_tecnico,
          firma_participante: detalle.detalle.firma_participante,
          tipo_autorizacion: detalle.detalle.tipo_autorizacion,
        };
      } else {
        return formData;
      }
    } catch (error) {
      console.error("Error al obtener datos del diagnóstico:", error);
      return formData; // fallback
    }
  };

  const obtenerDatosCompletosActaInicio = async (formData) => {
    try {
      const detalle = await getDetalleActaInicio(formData.id_participante);
      if (detalle?.success) {
        return detalle.detalle;
      } else {
        return formData;
      }
    } catch (error) {
      console.error("Error al obtener datos del diagnóstico:", error);
      return formData; // fallback
    }
  };

  const cargarCategoriasYProductos = async (productos) => {
    try {
      const response = await obtenerCategoriasProductos();

      if (response.success) {
        // Extraer categorías y productos en mapas para acceso rápido
        const categoriaMap = new Map(
          response.categorias.map((cat) => [cat.id, cat.nombre])
        );
        const productoMap = new Map(
          response.productos.map((prod) => [prod.id, prod.nombre])
        );

        // Verificar que `lista_productos_fortalecimiento_economico` sea un array antes de hacer `.map()`
        if (Array.isArray(productos)) {
          const listaFormateada = productos.map((item) => ({
            categoria: categoriaMap.get(item.categoria) || "Desconocido",
            productos: Array.isArray(item.producto)
              ? item.producto.map(
                  (id) => productoMap.get(id) || "Producto Desconocido"
                )
              : [],
          }));
          return listaFormateada;
        } else {
          return [];
        }
      } else {
        console.error(
          "Error al cargar categorías y productos:",
          response.message
        );
      }
    } catch (error) {
      console.error("Error al cargar datos:", error);
    }
  };

  const fetchVisitaTecnicaById_pdf = async (id) => {
    try {
      const response = await getVisitaTecnicaById(id);
      const { status, data } = response;

      if (status) {
        const { detalle, ...restoData } = data;

        const detalleCompleto = {
          ...detalle,
          ...restoData,
        };

        return detalleCompleto;
      } else {
        return null;
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    }
  };

  const fetchNovedadById_pdf = async (id) => {
    try {
      const response = await getNovedadById(id);
      const { status, data } = response;

      if (status) {
        return data;
      } else {
        return null;
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    }
  };

  const enviarPDFAlServidor = async (data, id, nombreTipo) => {
    try {

      let datosCompletos = data.detalle;

      // 🔍 Procesar según el tipo de documento (por ID)
      if (id === 2) {
        // Diagnóstico
        datosCompletos = await obtenerDatosCompletosDiagnostico(data.detalle);

        // ✅ Validar que existan firmas obligatorias
        const firmaTecnicoValida =
          typeof datosCompletos?.firma_tecnico === "string" &&
          datosCompletos.firma_tecnico.trim() !== "";
        const firmaParticipanteValida =
          typeof datosCompletos?.firma_participante === "string" &&
          datosCompletos.firma_participante.trim() !== "";

        if (!firmaTecnicoValida || !firmaParticipanteValida) {
          console.warn(
            "⚠️ No se generó el PDF: faltan firmas válidas para diagnóstico."
          );
          return {
            status: 400,
            message: "Faltan firmas válidas para generar el diagnóstico",
          };
        }
      }

      if (id === 5) {
        // Acta de inicio
        datosCompletos = await obtenerDatosCompletosActaInicio(data.detalle);
      }

      if (id === 3) {
        // Análisis de capacidades
        const responseProductos = await cargarCategoriasYProductos(
          datosCompletos?.lista_productos_fortalecimiento_economico || []
        );
        // 🛒 Agregar productos procesados al formData
        datosCompletos = { ...datosCompletos, productos: responseProductos };
      }

      if (id === 6) {
        // Visitas tecnicas

        datosCompletos = await fetchVisitaTecnicaById_pdf(data.id);
      }

      if (id === 7) {
        // 🔗 Enviar la data tal como llega
        datosCompletos = await fetchNovedadById_pdf(data.id);
      }

      if (id === 8) {
        // Medición  de capacidades de salida
        const responseProductos = await cargarCategoriasYProductos(
          datosCompletos?.lista_productos_fortalecimiento_economico || []
        );
        // 🛒 Agregar productos procesados al formData
        datosCompletos = { ...datosCompletos, productos: responseProductos };
      }

      // 🧩 Seleccionar el componente PDF correspondiente según el ID
      const componentesPDF = {
        1: <PdfAlmacenarConsentimiento formData={datosCompletos} />,
        2: <PdfAlmacenarDiagnostico formData={datosCompletos} />,
        3: <PdfAlmacenarAnalisisCapacidades formData={datosCompletos} />,
        4: <PdfAlmacenarAutorizacionImagen formData={datosCompletos} />,
        5: <PdfAlmacenarActaInicio formData={datosCompletos} />,
        6: <PdfAlmacenarVisitaTecnica formData={datosCompletos} />,
        7: <PdfAlmacenarNovedad formData={datosCompletos} />,
        8: <PdfAlmacenarMedicionCapacidadSalida formData={datosCompletos} />,
      };

      const componentePDF = componentesPDF[id];

      // ❌ Si no existe componente para el ID, lanzar error
      if (!componentePDF) {
        throw new Error(
          `No hay componente PDF definido para el tipo de visita con ID ${id}`
        );
      }

      // 🖨️ Generar el PDF en formato Blob
      const blob = await pdf(componentePDF).toBlob();

      // 📂 Preparar el FormData para enviar al servidor
      let nombreArchivo = "";
      //Ajustar el nombre del archivo en caso de que sea tipo novedad
      if (id === 7) {
        nombreArchivo = `${id}_${nombreTipo}_${data.id}_${data.fecha_archivo}.pdf`;
      } else if (id === 6) {
        // Convertir fecha_registro a formato con guiones bajos
        const fechaArchivo = data.fecha_registro.replace(/-/g, "_");
        nombreArchivo = `1_${nombreTipo}_${data.numero_visita}_${fechaArchivo}.pdf`;
      } else {
        nombreArchivo = `${id}_${nombreTipo}_${data.fecha_archivo}.pdf`;
      }
      const formDataToSend = new FormData();
      formDataToSend.append(
        "ruta",
        `${data.fecha_directorio}/${data.departamento_p}/${data.codigo_pre}/`
      );
      formDataToSend.append("nombre_archivo", nombreArchivo);
      formDataToSend.append("file", blob, nombreArchivo);

      let response = "";

      // 🚀 Enviar al endpoint correspondiente según el tipo de documento
      if (id === 6) {
        // Visita técnica
        response = await postSoporteVisitaTecnicaPatti(formDataToSend, data.id);
      } else if (id === 7) {
        // Novedad
        response = await postSoporteNovedad(formDataToSend, data.id);
      } else {
        // Otros documentos
        response = await postSoportePatti(formDataToSend, data.id);
      }

      // ✅ Devolver la respuesta del servidor
      return response;
    } catch (err) {
      // 🛑 Capturar errores y devolver mensaje estándar
      console.error("❌ Error al enviar el PDF:", err);
      return { status: 500, message: "Error al generar o enviar el PDF" };
    }
  };
  const onFinish = async () => {
    try {
      setLoading(true);
      setProcesoIniciado(true);

      let totalItems = 0;
      let procesados = 0;

      const contador = {};
      datosPrecargados.forEach((tipo) => {
        contador[tipo.nombreTipo] = {
          descripcion: tipo.descripcion, // <-- agrega la descripción aquí
          exitosos: 0,
          fallidos: 0,
          errores: [],
        };
      });

      // 🔑 Calcular total real
      datosPrecargados.forEach((tipo) => {
        totalItems += tipo.datosProcesados.length;
      });
      setTotal(totalItems);
      setProgreso(0);

      for (const tipo of datosPrecargados) {
        const { id, nombreTipo, datosProcesados } = tipo;

        if (!datosProcesados || datosProcesados.length === 0) {
          console.warn(
            `⚠️ No hay datos disponibles para procesar el formato: ${nombreTipo}`
          );
          continue;
        }

        for (const item of datosProcesados) {
          
          const respuestaPDF = await enviarPDFAlServidor(item, id, nombreTipo);
          procesados++;

          if (respuestaPDF?.status === 200) {
            contador[nombreTipo].exitosos += 1;
          } else {
            contador[nombreTipo].fallidos += 1;

            // Guardar detalle del error
            contador[nombreTipo].errores.push({
              id: item?.id || "Sin ID",
              detalle: item?.detalle || {},
              error: respuestaPDF?.message || "Error desconocido",
            });
          }

          // 🔄 Actualizar progreso real
          setProgreso(Math.round((procesados / totalItems) * 100));
        }
      }

      setResumen(contador);
      fetchSystemFyle();
      message.success("✅ Proceso completado para todos los formatos.");

      // 🔄 Refrescar datos precargados después de generar los PDFs
      await fetchData();
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Error",
        description: "Ocurrió un error durante el proceso.",
      });
    } finally {
      setLoading(false);
    }
  };

  const columnasErrores = [
    {
      title: "Codigo SIR",
      dataIndex: "detalle",
      key: "id_participante",
      width: 100,
      render: (detalle) => detalle.id_participante || "N/A",
    },
    {
      title: "Nombre Participante",
      dataIndex: "detalle",
      key: "nombre_participante",
      render: (detalle) => detalle.nombre_participante || "N/A",
    },
    // 👉 Columna condicional
    ...(tipoSeleccionado === "Visita"
      ? [
          {
            title: "Número de Visita",
            dataIndex: "detalle",
            key: "numero_visita",
            render: (detalle) => detalle.numero_visita || "N/A",
          },
        ]
      : []),
    {
      title: "Nombre Proyecto",
      dataIndex: "detalle",
      key: "nombre_proyecto",
      render: (detalle) => detalle.nombre_proyecto || "N/A",
    },
    {
      title: "Código PRE",
      dataIndex: "detalle",
      key: "codigo_pre",
      width: 150,
      render: (detalle) => detalle.codigo_pre || "N/A",
    },

    {
      title: "Resultado",
      dataIndex: "error",
      key: "error",
      render: (text) => text || "Error desconocido",
    },
  ];

  const hayDocumentosPorGenerar = datosPrecargados.some(
    (tipo) => tipo.datosProcesados.length > 0
  );

  return (
    <>
      {hayDocumentosPorGenerar && (
        <div>
          <Tooltip title="Actualiza el repositorio para generar los PDF de los formatos más recientes">
            <Button
              key="start"
              type="primary"
              icon={<DownloadOutlined />}
              onClick={() => setModalVisible(true)}
              loading={loading}
              style={{
                borderRadius: "6px",
                background: "linear-gradient(135deg, #32CD32 0%, #28a745 100%)",
                border: "none",
                boxShadow: "0 4px 12px rgba(40, 167, 69, 0.4)",
              }}
            >
              Actualizar repositorio
            </Button>
          </Tooltip>

          <Modal
            title={
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div
                  style={{
                    background: "#1A76D2",
                    borderRadius: "8px",
                    padding: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <FilePdfOutlined
                    style={{ color: "white", fontSize: "20px" }}
                  />
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#262626",
                      margin: 0,
                    }}
                  >
                    Generación de Documentos PDF
                  </div>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#8c8c8c",
                      marginTop: "2px",
                    }}
                  >
                    Sistema de generación automática de formatos
                  </div>
                </div>
              </div>
            }
            open={modalVisible}
            onCancel={() => {
              if (!loading) {
                setModalVisible(false);
                setProcesoIniciado(false);
                setResumen({});
                setProgreso(0);
              }
            }}
            footer={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingTop: "16px",
                  borderTop: "1px solid #f0f0f0",
                }}
              >
                <span style={{ fontSize: "12px", color: "#8c8c8c" }}>
                  {!procesoIniciado &&
                    `${datosPrecargados.reduce(
                      (sum, tipo) => sum + tipo.datosProcesados.length,
                      0
                    )} documentos listos para generar`}
                  {procesoIniciado && loading && "Procesando documentos..."}
                  {procesoIniciado && !loading && "Generación completada"}
                </span>

                <div style={{ display: "flex", gap: 8 }}>
                  {!loading && (
                    <Button
                      key="close"
                      icon={<CloseOutlined />}
                      onClick={() => {
                        setModalVisible(false);
                        setProcesoIniciado(false);
                        setResumen({});
                        setProgreso(0);
                      }}
                      style={{ borderRadius: "6px" }}
                    >
                      Cerrar
                    </Button>
                  )}
                  {!procesoIniciado && (
                    <Button
                      key="start"
                      type="primary"
                      icon={<DownloadOutlined />}
                      onClick={onFinish}
                      loading={loading}
                      style={{
                        borderRadius: "6px",
                        background: "#1A76D2",
                        border: "none",
                        boxShadow: "0 4px 12px rgba(102, 126, 234, 0.4)",
                      }}
                    >
                      Iniciar generación
                    </Button>
                  )}
                </div>
              </div>
            }
            closable={!loading}
            maskClosable={false}
            width={900}
            style={{ top: 40 }}
          >
            {!procesoIniciado ? (
              <div>
                {/* Alert mejorado */}
                <Alert
                  message="Actualización Requerida"
                  description="Actualiza el repositorio para generar los PDF de los formatos más recientes"
                  type="info"
                  showIcon
                  icon={<InfoCircleOutlined />}
                  style={{
                    marginBottom: 24,
                    borderRadius: "8px",
                    border: "1px solid #91d5ff",
                    backgroundColor: "#f6ffed",
                  }}
                />

                {/* Título de sección mejorado */}
                <div style={{ marginBottom: 24 }}>
                  <h3
                    style={{
                      color: "#262626",
                      marginBottom: 8,
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    <FileTextOutlined style={{ color: "#1890ff" }} />
                    Documentos que se van a generar:
                  </h3>
                  <span style={{ fontSize: "13px", color: "#8c8c8c" }}>
                    Los siguientes tipos de documentos serán procesados y
                    convertidos a formato PDF
                  </span>
                </div>

                {/* Grid mejorado */}
                <Row gutter={[20, 20]}>
                  {datosPrecargados.map(
                    (tipo) =>
                      tipo.datosProcesados.length > 0 && (
                        <Col xs={24} sm={12} key={tipo.nombreTipo}>
                          <div
                            style={{
                              border: "1px solid #f0f0f0",
                              borderRadius: 12,
                              padding: 20,
                              background:
                                "linear-gradient(135deg, #fafbff 0%, #f0f5ff 100%)",
                              textAlign: "left",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                              height: "100%",
                              transition: "all 0.3s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform =
                                "translateY(-2px)";
                              e.currentTarget.style.boxShadow =
                                "0 4px 16px rgba(0,0,0,0.12)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow =
                                "0 2px 8px rgba(0,0,0,0.06)";
                            }}
                          >
                            {/* Header del card */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                marginBottom: 16,
                              }}
                            >
                              <div
                                style={{
                                  background: "#1890ff",
                                  borderRadius: "8px",
                                  padding: "8px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <FilePdfOutlined
                                  style={{ color: "white", fontSize: "16px" }}
                                />
                              </div>
                              <div>
                                <h4
                                  style={{
                                    color: "#262626",
                                    fontWeight: "600",
                                    marginBottom: 4,
                                    fontSize: "15px",
                                  }}
                                >
                                  {tipo.descripcion}
                                </h4>
                                <span
                                  style={{ fontSize: "12px", color: "#8c8c8c" }}
                                >
                                  {tipo.descripcion}
                                </span>
                              </div>
                            </div>

                            {/* Separador */}
                            <div
                              style={{
                                height: "1px",
                                background: "#f0f0f0",
                                margin: "12px 0",
                              }}
                            />

                            {/* Footer del card */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Tag
                                icon={<FilePdfOutlined />}
                                color="processing"
                                style={{
                                  borderRadius: "16px",
                                  padding: "4px 12px",
                                  fontSize: "12px",
                                  fontWeight: "500",
                                }}
                              >
                                Total: {tipo.datosProcesados.length}
                              </Tag>

                              <span
                                style={{
                                  fontSize: "24px",
                                  fontWeight: "bold",
                                  color: "#1890ff",
                                }}
                              >
                                {tipo.datosProcesados.length}
                              </span>
                            </div>
                          </div>
                        </Col>
                      )
                  )}
                </Row>

                {/* Estadística total */}
                <div
                  style={{
                    marginTop: 24,
                    padding: "16px",
                    background: "#fafafa",
                    borderRadius: "8px",
                    border: "1px solid #f0f0f0",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#8c8c8c",
                      marginBottom: 8,
                    }}
                  >
                    Total de Documentos a Procesar
                  </div>
                  <div
                    style={{
                      fontSize: "28px",
                      fontWeight: "bold",
                      color: "#1890ff",
                    }}
                  >
                    <FilePdfOutlined style={{ marginRight: 8 }} />
                    {datosPrecargados.reduce(
                      (sum, tipo) => sum + tipo.datosProcesados.length,
                      0
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <>
                {/* Indicador visual del proceso */}
                <div style={{ textAlign: "center", marginBottom: 32 }}>
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                      background: loading
                        ? "conic-gradient(from 0deg, #1a76d2, #1e88e5, #1a76d2)"
                        : "linear-gradient(135deg, #52c41a 0%, #73d13d 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                      animation: loading ? "spin 2s linear infinite" : "none",
                    }}
                  >
                    {loading ? (
                      <FilePdfOutlined
                        style={{ color: "white", fontSize: "32px" }}
                      />
                    ) : (
                      <CheckCircleOutlined
                        style={{ color: "white", fontSize: "32px" }}
                      />
                    )}
                  </div>

                  <div
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      color: "#262626",
                      marginBottom: 8,
                    }}
                  >
                    {loading
                      ? "Generando Documentos PDF"
                      : "Proceso Completado Exitosamente"}
                  </div>
                  <div style={{ fontSize: "14px", color: "#8c8c8c" }}>
                    {loading
                      ? "Por favor espere mientras se procesan los documentos..."
                      : "Todos los documentos han sido generados correctamente"}
                  </div>
                </div>

                {/* Progress bar mejorada */}
                <Progress
                  percent={progreso}
                  status={loading ? "active" : "success"}
                  strokeWidth={8}
                  style={{ marginBottom: 32 }}
                  strokeColor={getColor(progreso)} // 🔥 Cambia dinámicamente
                  trailColor="#f0f0f0"
                />

                {/* Resumen mejorado */}
                {!loading && Object.keys(resumen).length > 0 && (
                  <div style={{ marginTop: 20 }}>
                    <h3
                      style={{
                        marginBottom: 20,
                        color: "#262626",
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      <CheckCircleOutlined style={{ color: "#52c41a" }} />
                      Resumen por formato:
                    </h3>

                    <Row gutter={[20, 20]}>
                      {Object.entries(resumen).map(
                        ([nombreTipo, resultados]) =>
                          (resultados.exitosos > 0 ||
                            resultados.fallidos > 0) && (
                            <Col xs={24} sm={12} key={nombreTipo}>
                              <div
                                style={{
                                  border: "1px solid #f0f0f0",
                                  borderRadius: 12,
                                  padding: 20,
                                  background: "white",
                                  textAlign: "left",
                                  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                                  height: "100%",
                                }}
                              >
                                <h4
                                  style={{
                                    color: "#262626",
                                    fontWeight: "600",
                                    marginBottom: 16,
                                    fontSize: "15px",
                                  }}
                                >
                                  {resultados.descripcion}
                                </h4>

                                {/* Estadísticas en formato profesional */}
                                <Row gutter={16}>
                                  <Col span={12}>
                                    <div style={{ textAlign: "center" }}>
                                      <div
                                        style={{
                                          fontSize: "12px",
                                          color: "#8c8c8c",
                                          marginBottom: 8,
                                        }}
                                      >
                                        Exitosos
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "24px",
                                          fontWeight: "bold",
                                          color: "#52c41a",
                                        }}
                                      >
                                        <CheckCircleOutlined
                                          style={{ marginRight: 4 }}
                                        />
                                        {resultados.exitosos}
                                      </div>
                                    </div>
                                  </Col>
                                  <Col span={12}>
                                    <div style={{ textAlign: "center" }}>
                                      <div
                                        style={{
                                          fontSize: "12px",
                                          color: "#8c8c8c",
                                          marginBottom: 8,
                                        }}
                                      >
                                        Fallidos
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "24px",
                                          fontWeight: "bold",
                                          color: "#ff4d4f",
                                          cursor:
                                            resultados.fallidos > 0
                                              ? "pointer"
                                              : "default",
                                        }}
                                        onClick={() => {
                                          if (resultados.fallidos > 0) {
                                            setDetalleErrores(
                                              resultados.errores
                                            );
                                            setTipoSeleccionado(nombreTipo);
                                            setModalErroresVisible(true);
                                          }
                                        }}
                                      >
                                        <CloseCircleOutlined
                                          style={{ marginRight: 4 }}
                                        />
                                        {resultados.fallidos}
                                      </div>
                                    </div>
                                  </Col>
                                </Row>

                                {resultados.fallidos > 0 && (
                                  <div
                                    style={{
                                      marginTop: 12,
                                      padding: "8px",
                                      background: "#fff2f0",
                                      borderRadius: "6px",
                                      border: "1px solid #ffccc7",
                                      textAlign: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        color: "#ff4d4f",
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                      }}
                                    >
                                      <Tag
                                        color="red"
                                        onClick={() => {
                                          if (resultados.fallidos > 0) {
                                            const erroresConKey =
                                              resultados.errores.map(
                                                (item, idx) => ({
                                                  ...item,
                                                  key: `${nombreTipo}-${idx}`, // 🔑 key estable y única
                                                })
                                              );

                                            setDetalleErrores(erroresConKey);
                                            setTipoSeleccionado(nombreTipo);
                                            setModalErroresVisible(true);
                                          }
                                        }}
                                      >
                                        Ver detalle del proceso →
                                      </Tag>
                                    </span>
                                  </div>
                                )}
                              </div>
                            </Col>
                          )
                      )}
                    </Row>
                  </div>
                )}
              </>
            )}

            {/* CSS para animaciones */}
            <style jsx>{`
              @keyframes spin {
                from {
                  transform: rotate(0deg);
                }
                to {
                  transform: rotate(360deg);
                }
              }
            `}</style>
          </Modal>
          <Modal
            title={
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div
                  style={{
                    background:
                      "linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)",
                    borderRadius: "8px",
                    padding: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ExclamationCircleOutlined
                    style={{ color: "white", fontSize: "20px" }}
                  />
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#262626",
                      margin: 0,
                    }}
                  >
                    Resultados de procesamiento - {tipoSeleccionado}
                  </div>
                </div>
              </div>
            }
            open={modalErroresVisible}
            onCancel={() => setModalErroresVisible(false)}
            footer={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingTop: "16px",
                  borderTop: "1px solid #f0f0f0",
                }}
              >
                <span style={{ fontSize: "12px", color: "#8c8c8c" }}>
                  {detalleErrores.length}{" "}
                  {detalleErrores.length === 1
                    ? "Resultado del procesamiento"
                    : "Resultados de procesamiento"}
                </span>

                <Button
                  key="cerrar"
                  type="primary"
                  icon={<CloseOutlined />}
                  onClick={() => setModalErroresVisible(false)}
                  style={{
                    borderRadius: "6px",
                    background:
                      "linear-gradient(135deg, #1a76d2 0%, #1e88e5 100%)",
                    border: "none",
                  }}
                >
                  Cerrar
                </Button>
              </div>
            }
            width={1000}
            style={{ top: 40 }}
          >
            {detalleErrores.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "60px 20px",
                  background:
                    "linear-gradient(135deg, #f6ffed 0%, #f0f9ff 100%)",
                  borderRadius: "12px",
                  border: "1px solid #d9f7be",
                }}
              >
                <div
                  style={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, #52c41a 0%, #73d13d 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 16px",
                  }}
                >
                  <CheckCircleOutlined
                    style={{ color: "white", fontSize: "24px" }}
                  />
                </div>

                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#262626",
                    marginBottom: 8,
                  }}
                >
                  No se encontraron errores
                </div>
                <div style={{ fontSize: "14px", color: "#8c8c8c" }}>
                  Todos los documentos se procesaron correctamente
                </div>
              </div>
            ) : (
              <Table
                columns={columnasErrores}
                dataSource={detalleErrores}
                rowKey="key"
                pagination={{ pageSize: 5 }}
                scroll={{ x: 1000 }}
                size="small"
                style={{
                  background: "white",
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                }}
                rowClassName={(record, index) =>
                  index % 2 === 0 ? "table-row-light" : "table-row-dark"
                }
              />
            )}

            {/* CSS personalizado para la tabla */}
            <style jsx>{`
              .table-row-light {
                background-color: #fafafa;
              }
              .table-row-dark {
                background-color: white;
              }
              .ant-table-thead > tr > th {
                background: linear-gradient(135deg, #f0f5ff 0%, #fff2f0 100%);
                font-weight: 600;
                color: #262626;
                border-bottom: 2px solid #f0f0f0;
              }
              .ant-table-tbody > tr:hover > td {
                background-color: #f0f5ff !important;
              }
            `}</style>
          </Modal>
        </div>
      )}
    </>
  );
};

export default GenerarTodosLosPDFs;
